import logoSBBH from 'src/assets/images/logos/logo-black-white.png';
import defaultUser from 'src/assets/images/default-user.png';
import emptyIcon from 'src/assets/images/empty-icon.svg';

export const IMAGES = {
  logoSBBH,
  defaultUser,
  emptyIcon,
};
